import { TagId, TagResponse } from '@business/entities/tag';
import { Endpoint } from '../endpoint';

export function fetchTags() {
  return Endpoint.get<TagResponse[]>(`@gc/tags`);
}

export function createTag(data: Partial<TagResponse>) {
  return Endpoint.post<TagResponse>(`@gc/tags`, { data });
}

export function updateTag(id: TagId, data: Partial<TagResponse>) {
  return Endpoint.patch<TagResponse>(`@gc/tags/${id}`, { data });
}

export function deleteTag(TagId: TagId) {
  return Endpoint.delete<void>(`@gc/tags/${TagId}`);
}

export function attachTags(objectId: string | number, classType: string, tags: string[]) {
  return Endpoint.post<string[]>(`@gc/tags/attach`, { data: { objectId, classType, tags } });
}

export function detachTag(objectId: string | number, classType: string, tag: string) {
  return Endpoint.post<string[]>(`@gc/tags/detach`, { data: { objectId, classType, tag } });
}
